import { Directive, ElementRef, SimpleChanges, OnInit, OnChanges, OnDestroy, EventEmitter, AfterContentInit } from '@angular/core';
import 'zc-angular/components/zohocomponents';

@Directive()
export class ZGeneral {
  element: any;
  initialProps: any = {};
  opts: any;
  isRendered: boolean = false;

  constructor(myEle: ElementRef) {
    //@ts-ignore
    this.element = myEle.nativeElement;
  }

  ngOnChanges(changes: SimpleChanges) {
    const changedAttr = Object.keys(changes);
    if (!this.isRendered) {
      return;
      // @ts-ignore
    }else{
   for (let i = 0; i < changedAttr.length; i++) {
       if(changedAttr[i]=='open'){
           if (changes.open.currentValue) {
                // @ts-ignore
                ZComponents[this.compName](this.element).open();
            } else {
                // @ts-ignore
                ZComponents[this.compName](this.element).close();
            }
       }else if (changes[changedAttr[i]].previousValue !== undefined && changes[changedAttr[i]].currentValue !== undefined) {
        // @ts-ignore
        if(this.compName=='option'){
            let parNode = this.element.parentNode,
            parTag = parNode.tagName.toLowerCase(),
            parComp = parTag.replace('z-','');
            //@ts-ignore
            ZComponents[parComp](parNode).setOptionAttributes(this.element, changedAttr[i], changes[changedAttr[i]].currentValue);
        }else{
            //@ts-ignore
            ZComponents[this.compName](this.element).setAttribute(changedAttr[i], changes[changedAttr[i]].currentValue);
        }
       }
    }
  }
  }

  ngOnInit() {
    //@ts-ignore
    console.log("CompName->",this.compName);
    this.isRendered = true;
    for (var i in this.opts) {
      if (this[this.opts[i]] != undefined) {
        this.initialProps[this.opts[i]] = this[this.opts[i]];
      }
    }
    //@ts-ignore
    if(this.compName == 'suggestfield'){
        this.initialProps.isCE=true;
    }

    // @ts-ignore
    if (this.compName == 'alertdialog') {
      // @ts-ignore
      ZComponents.AlertDialog.open(this.initialProps);
      // @ts-ignore
    } else if (this.compName == 'alertbanner') {
      // @ts-ignore
      ZComponents.AlertBanner.show(this.initialProps);
      // @ts-ignore
    } else if(this.compName == 'checkboxbutton' || this.compName =='radiobutton' || this.compName == 'menuItem' || this.compName == 'option' || this.compName == 'tab' || this.compName == 'accitem'){
        let parNode = this.element.parentNode,
        parTag = parNode.tagName.toLowerCase(),
        parComp = parTag.replace('z-','');
        //@ts-ignore
		if(parComp=='buttongroup' || this.compName == 'menuItem' || this.compName == 'option' || this.compName == 'tab' || this.compName == 'accitem'){
		    //@ts-ignore
		    let parentNodeData = ZComponents.DOMUtil(parNode).data();
		    //@ts-ignore
		    if(this.compName =='option'){
		        //@ts-ignore
                ZComponents[parComp](parNode).setOptionAttributes(this.element, this.initialProps);
		    }else{
		        for(var i in this.initialProps){
                    var dashed = i.replace(/[A-Z]/g, m => "-" + m.toLowerCase());
		            this.element.setAttribute("data-"+dashed,this.initialProps[i]);
                }
		    }
		} else {
		    // @ts-ignore
            ZComponents[this.compName](this.element, this.initialProps);
		}
    }else{
      // @ts-ignore
      ZComponents[this.compName](this.element, this.initialProps);
    }
    //@ts-ignore
    let eventArr = this.events, len = eventArr.length, cname = this.compName, base = this;
    for (let i = 0; i < len; i++) {
      let eveName = eventArr[i];
      //@ts-ignore
      $zc(this.element).on('z' + cname + eveName, function (event) {
        if (base['z' + eveName]) {
          base['z' + eveName].emit(event);
        }
      });
    }
  }

  ngOnDestroy() {
     // @ts-ignore
    if (this.compName == 'alertdialog') {
      // @ts-ignore
      ZComponents.AlertDialog.close();
      // @ts-ignore
    } else if (this.compName == 'alertbanner') {
      // @ts-ignore
      ZComponents.AlertBanner.hide();
    } else {
      // @ts-ignore
      ZComponents[this.compName](this.element).destroy();
    }
  }
}
